/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useContext } from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { Popover } from '@oneaudi/unified-web-components';
import type { AudiHeaderDealerProps } from '../../interfaces/header-components.interfaces';
import { StyledIconButton } from './AudiHeaderDealerContextStyles';
import { messages } from '../../i18n/messages';
import { DealerContext } from '../../context';
import { DEALER_CONTEXT_UNSUBSCRIBE, NAVIGATION_CLASSNAME } from '../../utils/globals';
import AudiHeaderAdditionalDealerDataAlpha from './AudiHeaderAdditionalDealerData_alpha';
import { truncate } from '../../utils/string-utils';
import styled from 'styled-components';

const StyledButtonContainer = styled.div`
  cursor: pointer;
`;

const AudiHeaderDealerContextAlpha: React.FC<AudiHeaderDealerProps> = ({
  isMobileView = false,
  onClickDealerContext,
  showDealerAdditionalData,
  showDealerSearch,
}) => {
  const { dealerData } = useContext(DealerContext);
  const dealerButtonLabelAria = useI18n(messages.dealer_information);
  const dealerButtonLabelAriaClose = useI18n(messages.dealer_information_close);

  const buttonLabel = !isMobileView
    ? truncate(dealerData?.additionalData?.displayName || dealerData?.name)
    : dealerData?.additionalData?.displayName || dealerData?.name || 'Name not found';

  if (dealerData?.toString() === DEALER_CONTEXT_UNSUBSCRIBE) {
    return null;
  }

  return (
    <>
      {!isMobileView && dealerData ? (
        <Popover
          content={
            <AudiHeaderAdditionalDealerDataAlpha
              open={showDealerAdditionalData}
              isMobileView={isMobileView}
              refDealerData={null}
              showDealerSearch={showDealerSearch}
            />
          }
          data-testid="dealerContext-test-id"
          id="dealerContext"
          onClose={onClickDealerContext}
          triggerElement={
            <StyledButtonContainer onClick={onClickDealerContext}>
              <StyledIconButton
                aria-label={
                  showDealerAdditionalData ? dealerButtonLabelAriaClose : dealerButtonLabelAria
                }
                data-testid="test-id"
                icon={showDealerAdditionalData ? 'cancel' : 'poi-active'}
                iconPosition="leading"
                onClick={onClickDealerContext}
                size="md"
                title={buttonLabel}
                type="button"
                variant="tertiary"
                className={NAVIGATION_CLASSNAME}
                // @ts-expect-error
                selected={showDealerAdditionalData}
              >
                {buttonLabel}
              </StyledIconButton>
            </StyledButtonContainer>
          }
          withTip={false}
          open={showDealerAdditionalData}
          alignment="center"
          placement="top"
        />
      ) : null}
    </>
  );
};

export default AudiHeaderDealerContextAlpha;
